import TemplateCategoryNewRow from './TemplateCategoryNewRow';
import {connect} from '../../app/connect';
import {createTemplateCategoryAction} from '../../app/templates/templates-actions';
import {
  getIsTemplateCategoryCreateInProgress,
  getTemplateCategoryTitlesForUniqueValidation
} from '../../app/templates/template-selectors';

const mapStateToProps = state => ({
  loading: getIsTemplateCategoryCreateInProgress(state),
  templateCategoryTitles: getTemplateCategoryTitlesForUniqueValidation(state)
});

const mapDispatchToProps = {
  createTemplateCategoryAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemplateCategoryNewRow);
